import { type ISelectRow } from "../libs/dropdown/Dropdown";
import { ESectors } from "../shared/Consts";
import PortUtils from "./PortUtils"

export const SectorOptions:ISelectRow<number>[] =
     Object.keys(ESectors).map(key => parseInt(key)).filter(key => !isNaN(key)).map(key => ({value:key,label:PortUtils.sector(key)}))
     .sort( (l,r) => l.label.localeCompare(r.label))
export const ValidSectorOptions = SectorOptions.filter(sector => sector.value>=0 || sector.value==ESectors.Mixed)
 

